import { ClassProps } from "@/lib/types/class-props";
import { cx } from "@/lib/utils/className.utils";
import { VariantProps, cva } from "class-variance-authority";
import React from "react";

const skeletonVariants = cva("rounded-lg h-8 animate-pulse bg-gray/40", {
  variants: {
    size: {
      sm: "h-4",
      md: "h-6",
      lg: "h-8",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export type SkeletonProps<T extends React.ElementType> = VariantProps<
  typeof skeletonVariants
> & { as?: T } & ClassProps;

const Skeleton = <T extends React.ElementType = "div">({
  className,
  size,
  as,
  ...props
}: SkeletonProps<T>) => {
  const Component = as || "div";
  return (
    <Component
      className={cx(
        as ? "" : skeletonVariants({ size }),
        className?.includes("w-") ? "" : "w-full",
        className
      )}
      {...props}
    ></Component>
  );
};

export default Skeleton;
